/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonFileInfo,
    JsonFileInfoFromJSON,
    JsonFileInfoFromJSONTyped,
    JsonFileInfoToJSON,
} from './JsonFileInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonFileInfo
 */
export interface ApiResultOfListOfJsonFileInfo {
    /**
     * 
     * @type {Array<JsonFileInfo>}
     * @memberof ApiResultOfListOfJsonFileInfo
     */
    data?: Array<JsonFileInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonFileInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonFileInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonFileInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonFileInfo
     */
    result?: ApiResultOfListOfJsonFileInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonFileInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonFileInfoFromJSON(json: any): ApiResultOfListOfJsonFileInfo {
    return ApiResultOfListOfJsonFileInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonFileInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonFileInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonFileInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonFileInfoToJSON(value?: ApiResultOfListOfJsonFileInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonFileInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

